<template>
  <div>
    <!-- 联系我们 -->
    <div class="Contact_Us">
      <div class="title_box">
        <div class="en">CONTACT US</div>
        <div class="zh">联系我们</div>
        <div class="line"></div>
      </div>
      <div class="content_box">
        <div class="map_box">
          <baidu-map
            class="bm-view"
            :center="chengdu"
            style="width: 100%; height: 100%"
            :zoom="15"
            :scroll-wheel-zoom="true"
          >
            <bm-marker
              :position="chengdu"
              :dragging="true"
              animation="BMAP_ANIMATION_BOUNCE"
            >
            </bm-marker>
          </baidu-map>
        </div>
        <div class="info_box">
          <div class="name">宜宾天亿新材料科技有限公司</div>
          <div class="address">地址：四川省宜宾市三江新区港园路西段61号 </div>
          <!-- <div class="tel">电话：0831-7803061</div> -->
          <div class="phone">管道 400-002-0026 </div>
          <div class="phone">地板 400-666-2151</div>
          <div class="time">周一至周五08:30-17:30（节假日除外）</div>
          <div class="dis">
          <div>
              <div class="qrCode">
            <img :src="rqCodeimg" class="img_cover" alt="" />
          </div>
          <div class="wxCode">宜宾天亿新材料官方微信公众号</div>
          </div>
               <div>
              <div class="qrCode">
            <img :src="rqCodeimga" class="img_cover" alt="" />
          </div>
          <div class="wxCode">仟领硅晶地板官方账号</div>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getConfig } from "../../http/api";
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      rqCodeimg: require("../../assets/components_img/temporary/rqCodeImg.png"),
        rqCodeimga: require("../../assets/indexImg/wx2.jpg"),
      // 成都公司地址
      chengdu: {
        // 经度104.070602
        lng: 104.06229124922944,
        // 纬度30.549261
        lat: 30.544565582141157,
      },
    };
  },
  methods: {},
  created() {
    getConfig().then((res) => {
      this.rqCodeimg = res.data.qrcode;
      this.chengdu.lng = res.data.lng;
      this.chengdu.lat = res.data.lat;
    });
  },
};
</script>

<style scoped lang='scss'>
.Contact_Us {
  width: 1322px;
  // height: 585px;
  height: 58.5vh;
  margin: 0 auto;
  // margin-top: 40px;
  margin-top: 4vh;
  .title_box {
    width: 456px;
    // height: 90px;
    height: 9vh;
    position: relative;
    margin: 0 auto;
    .en {
      width: 100%;
      height: 100%;
      font-size: 68px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      // line-height: 90px;
      line-height: 9vh;
      color: rgba(255, 255, 255, 0.1);
    }
    .zh {
      width: 100%;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
      position: absolute;
      // bottom: 10px;
      bottom: 1vh;
    }
    .line {
      width: 80px;
      height: 4px;
      background: #0fffff;
      margin: 0 auto;
    }
  }
  .content_box {
    width: 100%;
    // height: 435px;
    height: 43.5vh;
    // margin-top: 60px;
    margin-top: 6vh;
    display: flex;
    .map_box {
      width: 824px;
      // height: 435px;
      height: 43.5vh;
      margin-left: 71px;
    }
    .info_box {
      height: 100%;
      margin-left: 80px;
      max-width: 345px;
          .dis{
        display: flex;
        div{
        margin-right: 10px;
        }
        }
      .qrCode {
        width: 196px;
        height: 196px;
        // height: 19.6vh;
        margin: 4vh 0 1vh 0;
        // margin: 40px 0 10px 0;
    
      }
      .wxCode {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
      }
      .name {
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
      }
      .tel {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }
      .phone {
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #ffffff;
        // margin: 40px 0 10px 0;
        // margin: 4vh 0 1vh 0;
        margin: 1vh 0 1vh 0;

      }
      .time {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
      }
      .address {
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        margin: 10px 0;
      }
    }
  }
}
</style>